var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteForever(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.027,
    height: 11.607,
    viewBox: "0 0 9.027 11.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.145,14.817a1.293,1.293,0,0,0,1.29,1.29h5.159a1.293,1.293,0,0,0,1.29-1.29V7.079H8.145Zm1.586-4.591.909-.909,1.373,1.367,1.367-1.367.909.909-1.367,1.367L14.29,12.96l-.909.909L12.014,12.5l-1.367,1.367-.909-.909L11.1,11.593Zm4.539-5.081L13.626,4.5H10.4l-.645.645H7.5v1.29h9.027V5.145Z",
    transform: "translate(-7.5 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteForever);
export default __webpack_public_path__ + "static/media/deleteForever.a7472a7f60ac36226ee3a1b54afc50de.svg";
export { ForwardRef as ReactComponent };